import React, {FC} from "react";
import {useDispatch, useSelector} from "react-redux";
import {IRootState} from "../../store/configureStore";
import {actions} from "../../store/sliceApp";
import {ContextBackgroundBody} from "./ContextBackgroundStyle";

const ContextBackground: FC = () => {
    const {contextBackground} = useSelector((state: IRootState) => state.app)
    const dispatch = useDispatch()

    return(
        <ContextBackgroundBody loading={contextBackground} onClick={e => dispatch(actions.setContextBackground(false))}/>
    )
}
export default ContextBackground
